import React from 'react';

import { StyledGradeBookGrade } from './styled';

interface PropsType {
	finaleGrade: string | number;
}

function GradeBookFinaleGrades({ finaleGrade }: PropsType) {
	if (!finaleGrade) return null;

	if (finaleGrade === 'Completed') {
		return (
			<StyledGradeBookGrade
				sx={{
					backgroundColor: '#99C2FD',
					borderRadius: '12px',
					width: 'auto',
					padding: '0 4px',
				}}
			>
				{finaleGrade}
			</StyledGradeBookGrade>
		);
	}
	return (
		<StyledGradeBookGrade
			sx={{
				backgroundColor: '#99C2FD',
			}}
		>
			{finaleGrade}
		</StyledGradeBookGrade>
	);
}

export default GradeBookFinaleGrades;
